import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface FeedbackFilterProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: (filters: { fromDate?: string; toDate?: string }) => void;
  onClear: () => void;
}

const FeedbackFilter: React.FC<FeedbackFilterProps> = ({
  isOpen,
  onClose,
  onApply,
  onClear,
}) => {
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);

  if (!isOpen) return null;

  const formatLocalDate = (date: Date | null) => {
    if (!date) return undefined;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  // const handleApply = () => {
  //   onApply({
  //       fromDate: fromDate ? fromDate.toISOString() : undefined,
  //     toDate: toDate ? toDate.toISOString() : undefined,
  //   });
  //   onClose();
  // };
  const handleApply = () => {
    onApply({
      fromDate: formatLocalDate(fromDate),
      toDate: formatLocalDate(toDate),
    });
    onClose();
  };

  const handleClear = () => {
    setFromDate(null);
    setToDate(null);
    onClear();
  };

  return (
    <div className="absolute right-0 z-10 bg-white rounded-lg shadow w-96 mt-2">
      <div className="flex items-center justify-between p-3 border-b border-lightgray-100">
        <h3 className="text-base font-semibold text-grease-100">Filters</h3>
        <button onClick={onClose}>
          <svg className="w-3 h-3" viewBox="0 0 14 14">
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
          </svg>
        </button>
      </div>
      <div className="p-4">
        <p className="text-sm">Feedback Date</p>
        <div className="flex gap-4 mt-3">
          <div>
            <label className="text-xs text-gray-500">From Date</label>
            <DatePicker
              selected={fromDate}
              onChange={(date: Date | null) => setFromDate(date)}
              dateFormat="yyyy-MM-dd"
              placeholderText="Select from date"
              className="p-3 rounded-lg bg-white text-xs w-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-royalblue-100"
              maxDate={toDate || undefined} // Prevent selecting after toDate
            />
          </div>
          <div>
            <label className="text-xs text-gray-500">To Date</label>
            <DatePicker
              selected={toDate}
              onChange={(date: Date | null) => setToDate(date)}
              dateFormat="yyyy-MM-dd"
              placeholderText="Select to date"
              className="p-3 rounded-lg bg-white text-xs w-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-royalblue-100"
              minDate={fromDate || undefined} // Prevent selecting before fromDate
            />
          </div>
        </div>
      </div>
      <div className="flex justify-between p-3">
        <button
          className="px-3 py-2 bg-blue-500 bg-opacity-25 rounded-md"
          onClick={onClose}
        >
          Cancel
        </button>
        <div className="flex gap-4">
          <button
            className="px-3 py-2 border border-[#FFD700] rounded-md"
            onClick={handleClear}
          >
            Clear All
          </button>
          <button
            className="px-3 py-2 bg-[#FFD700] rounded-md text-white"
            onClick={handleApply}
          >
            Apply
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeedbackFilter;
